export default __webpack_public_path__ + "static/media/contactside.85c5e644.jpg";